export default __webpack_public_path__ + "static/media/AGWE.692cea1f.png";